<template>
  <div class="main-content-wrapper review-contest">
    <Menu v-if="activeSection.isReviewContest && isEdited"></Menu>
    <Menu v-if="isEdited && !activeSection.isReviewContest" :activeSection="activeSection" @goBackToComponent="goBackToComponent"></Menu>
    <transition name="fade">
      <div v-if="activeSection.isReviewContest">
        <h1 v-if="isEdited" class="title">{{contest.name}}</h1>
        <h1 v-else>Review your Contest</h1>
        <span  v-if="!isEdited" class="subcontent">You can edit the contest anytime before it starts.</span>
        <div class="contest-box">
          <div v-if="isEdited && contest.status != 'Live' && contest.status != 'Completed'">
            <h4 class="left-part">Settings</h4>
            <button class="change-btn right-part" @click="editSettings">Edit</button>
          </div>
          <div class="contest-box-inner rules">
            <div v-if="contest.name">
              <h6 class="left-part">Contest Name<span>{{contest.name}}</span></h6>
            </div>
            <div v-if="contest.desc">
              <h6 class="left-part">Description<span>{{contest.desc}}</span></h6>
            </div>
            <div>
              <h6 v-if="contest.online_date && contest.offline_date" class="left-part">Period<span>{{contest.online_date | relativeShortDate }} -  {{contest.offline_date | relativeShortDate }}</span></h6>
            </div>
            <div>
              <h6 v-if="contest.code" class="left-part">Join Code<span>{{contest.code}}</span></h6>
            </div>
            <div>
              <h6 v-if="contest.status" class="left-part">Status<span :class="contest.status">{{contest.status}}</span></h6>
            </div>
          </div>
        </div>
        <loading-state :state="ruleState"></loading-state>
        <div class="contest-box"  v-if="ruleState.isLoaded()">
          <div v-if="isEdited && contest.status != 'Live' && contest.status != 'Completed'">
            <h4 class="left-part">Rules</h4>
            <button class="change-btn right-part" @click="changeRule">Change</button>
          </div>
          <div class="contest-box-inner">
            <div class="rules">
              <h6 class="left-part">Rules<span>{{ruleInfo.name}}</span></h6>
              <div class="right-part">
                <img src="@/assets/imgs/rule-preview.svg">
              </div>
              <ul class="top-space">
                <li class="rule" v-if="ruleInfo.min_participants && ruleInfo.max_participants">
                  <span class="rule-title">{{ruleInfo.min_participants}}-{{ruleInfo.max_participants}}<span>Participants can join</span></span>
                </li>
                <li class="rule" v-if="ruleInfo.max_teams">
                  <span class="rule-title">{{ruleInfo.max_teams}}-{{ruleInfo.max_teams}}<span>Teams you can submit</span></span>
                </li>
                <li class="rule" v-if="ruleInfo.min_players && ruleInfo.max_players">
                  <span class="rule-title">{{ruleInfo.min_players}}-{{ruleInfo.max_players}}<span>Players to be selected</span></span>
                </li>
                <li class="rule" v-if="ruleInfo.min_teams && ruleInfo.max_teams">
                  <span class="rule-title">{{ruleInfo.min_teams}}-{{ruleInfo.max_teams}}<span>Teams</span></span>
                </li>
                <li class="rule" v-if="ruleInfo.max_players_per_team && ruleInfo.min_players_per_team">
                  <span class="rule-title">{{ruleInfo.min_players_per_team}}-{{ruleInfo.max_players_per_team}}<span>players per team</span></span>
                </li>
                <li class="rule" v-if="ruleInfo.min_matches && ruleInfo.max_matches">
                  <span class="rule-title">{{ruleInfo.min_matches}}-{{ruleInfo.max_matches}}<span>Matches</span></span>
                </li>
                <li class="rule" v-if="ruleInfo.min_players_per_match && ruleInfo.max_players_per_match">
                  <span class="rule-title">{{ruleInfo.min_players_per_match}}-{{ruleInfo.max_players_per_match}}<span>Players per match</span></span>
                </li>
                <li class="rule" v-for="(value, key) in ruleInfo.min_players_by_role" :key="key" v-if="ruleInfo.min_players_by_role">
                  <span class="rule-title">{{ruleInfo.min_players_by_role[key]}}-{{ruleInfo.max_players_by_role[key]}}<span>{{key | capitalise}}</span></span>
                </li>
                <li class="rule">
                  <span class="rule-title">{{ruleInfo.credits}}<span>Credits</span></span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <loading-state :state="rewardState"></loading-state>
        <div class="contest-box"  v-if="rewardState.isLoaded()">
          <div v-if="isEdited && contest.status != 'Live' && contest.status != 'Completed'">
            <h4 class="left-part">Reward</h4>
            <button class="change-btn right-part" @click="editReward">Change</button>
          </div>
          <div class="contest-box-inner">
            <div class="rules reward">
              <h6 class="left-part">Reward<span v-if="rewardInfo.kind && rewardInfo.kind.value">
                <span v-if="rewardInfo.kind.value == 'MedalByRank'">Medal By Rank</span>
                <span v-else-if="rewardInfo.kind.value == 'ChipsByRank'">Chips By Rank</span>
                <span v-if="rewardInfo.kind.value == 'ChipsByPoint'">Chips By Point</span>
                </span></h6>
              <div class="right-part">
                <img src="@/assets/imgs/icon-rewards.svg">
              </div>
              <ul class="rule-table" v-if="rewardInfo.kind && rewardInfo.kind.isMedalByRank">
                <li class="rule"
                v-for="(medal, i) in rewardInfo.rank_medals"
                :key="i"
                >
                <span>Rank upto
                  {{rewardInfo.rank_break_points[i]}}
                </span>
                <h3>{{medal}}</h3>
                </li>
              </ul>
              <ul class="rule-table" v-else-if="rewardInfo.kind && rewardInfo.kind.isChipsByRank">
                <li class="rule"
                v-for="(chips, i) in rewardInfo.rank_chips"
                :key="i"
                >
                  <span>Rank upto
                    {{rewardInfo.rank_break_points[i]}}
                  </span>
                  <h3>{{chips}}$</h3>
                </li>
              </ul>
              <div v-else-if="rewardInfo.kind && rewardInfo.kind.isChipsByPoint">
                <span>{{rewardInfo.chips_per_point}}$ per point / 
                {{rewardInfo.max_chips}}$ Max </span>
                <span v-if="rewardInfo.default_participants_chips > 0">
                  {{rewardInfo.default_participants_chips}}$ default price
                </span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="games">
          <div>
            <div>
              <h4 class="left-part">Games</h4>
              <button class="change-btn yellow right-part" @click="createGame">Create Game</button>
            </div>
            <div>
              <div class="games" v-if="games.length > 0">
                <div class="contest-box"
                  v-for="preview in games"
                  :key="preview.game.key"
                >
                  <game-preview
                    :contest="contest"
                    :game="preview.game"
                    :preview="preview"
                    ></game-preview>
                </div>
              </div>
              <div class="error-resp" v-else>No games available</div>
            </div>
          </div>
        </div>
        <button v-if="!isEdited" class="create-btn" @click="saveContest(contest)">Save Contest
        </button>
        <button v-if="isEdited" class="change-btn archive" @click="deleteContest(contest)">Archive Contest</button>
        <button v-if="isEdited" class="create-btn" @click="goToFGContest(contest)">Go to Contest</button>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="activeSection.isChangeRule">
        <el-tabs v-model="activeName">
          <el-tab-pane label="Public Rules" name="first">
            <RuleChangeWidget 
              :ruleState="statePublicRules" 
              :type="'public'" 
              :changeObj="publicRules" 
              :rule="contestRule"
              @editRule="editRule" 
              @saveRule="saveRule" 
              @createRule="createRule"
              @updatedRuleInfo="updatedRuleInfo"></RuleChangeWidget>
          </el-tab-pane>
          <el-tab-pane label="My App Rules" name="second">
            <RuleChangeWidget 
              :ruleState="stateAppRules" 
              :type="'app'" 
              :changeObj="appRules" 
              :showEdit="true" 
              :rule="contestRule"
              @saveRule="saveRule" 
              @editRule="editRule" 
              @createRule="createRule" 
              @updatedRuleInfo="updatedRuleInfo"
              @getAppRules="getAppRules"></RuleChangeWidget>
          </el-tab-pane>
        </el-tabs>
        <!-- <rule-change-widget :changeObj="changeObj" :pagination="changeObj" @saveRule="saveRule"></rule-change-widget> -->
      </div>
    </transition>
    <transition name="fade">
      <div v-if="activeSection.isCreateRule">
        <CreateRuleWrapper :ruleKey="ruleKey" @rulesaved="rulesaved"></CreateRuleWrapper>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="activeSection.isChangeReward">
        <el-tabs v-model="activeName">
          <el-tab-pane label="Public Rewards" name="first">
            <loading-state :state="statePublicRewards"></loading-state>
            <div v-if="statePublicRewards.isLoaded()">
              <RewardChangeWidget 
                :type="'public'" 
                :changeObj="publicRewards" 
                :reward="contestReward"
                @saveReward="saveReward" 
                @editReward="editRewardInfo"
                @createReward="createReward"
                @updatedRewardInfo="updatedRewardInfo"></RewardChangeWidget>
            </div>
          </el-tab-pane>
          <el-tab-pane label="App Rewards" name="second">
            <loading-state :state="stateAppRewards"></loading-state>
            <div v-if="stateAppRewards.isLoaded()">
              <RewardChangeWidget 
                :type="'app'" 
                :changeObj="appRewards" 
                :showEdit="true" 
                :reward="contestReward"
                @saveReward="saveReward" 
                @createReward="createReward"
                @editReward="editRewardInfo"
                @getAppRewards="getAppRewards"></RewardChangeWidget>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="activeSection.isCreateReward">
        <CreateRewardWrapper :rewardKey="rewardKey" @rewardsaved="rewardsaved"></CreateRewardWrapper>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="activeSection.isChangeSettings">
        <h1 class="title">Settings</h1>
        <div class="edit-box first">
          <label>Name</label>
          <div>
            <el-input class="new-rule" placeholder="Name of the contest" v-model="contest.name" clearable></el-input><span class="edit-icon"><img src="@/assets/imgs/edit-icon.svg"></span>
          </div>
        </div>
        <div class="edit-box">
          <label>Description</label>
          <div>
            <el-input class="new-rule" placeholder="Description" v-model="contest.desc" clearable></el-input><span class="edit-icon"><img src="@/assets/imgs/edit-icon.svg"></span>
          </div>
        </div>
        <div class="edit-box">
          <label>Sport</label>
          <div>
            <el-input class="new-rule" placeholder="Description" v-model="contest.sport" clearable></el-input><span class="edit-icon"><img src="@/assets/imgs/edit-icon.svg"></span>
          </div>
        </div>
        <div class="edit-box">
          <label>Join Code</label>
          <div>
            <el-input class="new-rule" placeholder="Description" v-model="contest.code" clearable></el-input><span class="edit-icon"><img src="@/assets/imgs/edit-icon.svg"></span>
          </div>
        </div>
        <div class="edit-box">
          <label>Leaderboard</label>
          <div class="leaderboard-section">
            <el-switch
              v-model="contest.have_leaderboard"
              :active-text="contest.have_leaderboard ? 'DISABLE' : 'ENABLE'">
            </el-switch>
          </div>
        </div>
        <button class="create-btn" @click="saveContest(contest)">Save Contest
        </button>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="activeSection.isCreateGame">
        <CreateGameWrapper :type="'edit'" @saveGame="saveGame"></CreateGameWrapper>
      </div>
    </transition>
  </div>
</template>
<script>
import { Enum } from '@/helpers/enum'
import { DataState, WizardManager } from '@/state'
import { Rule, Reward } from '@/models/fantasyconsole/rule'
import RuleChangeWidget from '@/components/fantasyconsole/RuleChangeWidget'
import RewardChangeWidget from '@/components/fantasyconsole/RewardChangeWidget'
import GamePreview from '@/components/fantasyconsole/GamePreview'
import CreateRuleWrapper from '@/components/fantasyconsole/CreateRuleWrapper'
import CreateRewardWrapper from '@/components/fantasyconsole/CreateRewardWrapper'
import CreateGameWrapper from '@/components/fantasyconsole/CreateGameWrapper'

export const Step = new Enum({
  ReviewContest: 'review contest',
  ChangeRule: 'Change Rule',
  CreateRule: 'CreateRule',
  ChangeReward: 'reward',
  CreateReward: 'Create Reward',
  ChangeSettings: 'settings',
  CreateGame: 'Create Game'
})

export default {
  components: {
    RuleChangeWidget,
    RewardChangeWidget,
    GamePreview,
    CreateRuleWrapper,
    CreateRewardWrapper,
    CreateGameWrapper
  },
  props: {
    contest: {
      type: Object
    },
    games: {
      type: Array,
      default: null
    },
    isEdited: false
  },

  data () {
    return {
      ruleManager: null,
      state: DataState.newNotInit(),
      stateAppRules: DataState.newLoading(),
      statePublicRules: DataState.newLoading(),
      stateAppRewards: DataState.newLoading(),
      statePublicRewards: DataState.newLoading(),
      matchKey: null,
      activeSection: Step.ReviewContest,
      ruleInfo: {},
      rewardInfo: {},
      publicRules: {},
      publicRewards: {},
      activeName: 'first',
      appRules: {},
      appRewards: {},
      ruleKey: null,
      rewardKey: null,
      contestRule: null,
      contestReward: null,
      ruleState: DataState.newLoading(),
      rewardState: DataState.newLoading()
    }
  },

  mounted () {
    this.wizardManager = JSON.parse(localStorage.getItem('wizardManager'))
    console.log('this.contest', this.contest)
    if (this.contest.rule) {
      this.getRule(this.contest.rule)
      this.contestRule = this.contest.rule
    }
    if (this.contest.reward) {
      this.getReward(this.contest.reward)
      this.contestReward = this.contest.reward
    }

    if (this.isEdited) {
      WizardManager.createWizard(this.activeSection, this.contest)
    }
    
    if (WizardManager.flow.length < 1) {
      this.getWizardmanager()
    }
  },
  watch: {
    'activeSection' () {
      if ( this.activeSection && this.activeSection.isReviewContest) {
        if (this.contest.rule) {
          this.getRule(this.contest.rule)
          this.contestRule = this.contest.rule
        }
        if (this.contest.reward) {
          this.getReward(this.contest.reward)
          this.contestReward = this.contest.rule
        }
        WizardManager.createWizard(this.activeSection, this.contest)
      }

      if (this.activeSection && this.activeSection.isChangeRule) {
        this.getAllrules()
        this.getAppRules()
      } else if (this.activeSection && this.activeSection.isChangeReward) {
        this.getAllreward()
        this.getAppRewards()
      }
    }
  },
  methods: {
     getWizardmanager () {
      if (this.wizardManager) {
        for (let section of this.wizardManager.flow) {
          const found = WizardManager.flow.some(el => el.key === section.key)
          if (!found) {
            WizardManager.flow.push(section)
          }
        }
        if (!this.activeSection) { 
          this.activeSection = Step[WizardManager['flow'][WizardManager.flow.length - 1]['key']]
        }
        this.contest = this.wizardManager.stateData
        if (this.wizardManager.stateData.rule && !this.contestRule) { 
          this.contestRule = this.wizardManager.stateData.rule
          this.getRule(this.contestRule)
        }
        if (this.wizardManager.stateData.reward && !this.contestReward) {
          this.contestReward = this.wizardManager.stateData.reward
          this.getReward(this.contestReward)
        }
      }
    },

    saveContest (contest) {
      if (contest && contest.key) {
        contest.leaderBoard = contest.have_leaderboard
      }
      this.$emit('saveContest', contest)
      WizardManager.flow.pop()
      WizardManager.stateData = contest
      localStorage.setItem('wizardManager', JSON.stringify(WizardManager))
      if (this.isEdited) {
        this.activeSection = Step.ReviewContest
      }
    },
    deleteContest (contest) {
      contest.is_archived = true
      this.$emit('deleteContest', contest)
    },
    goBackToComponent (page) {
      this.activeSection = Step[page['key']]
    },
    getRule (rule) {
      Rule.getRule(rule).then((resp) => {
        this.ruleInfo = resp
        this.ruleState.changeToLoaded()
      }).catch((error) => {
        this.ruleState.changeToError(error)
      })
    },
    getReward (reward) {
      Reward.getReward(reward).then((resp) => {
        this.rewardInfo = resp
        this.rewardState.changeToLoaded()
      }).catch((error) => {
        this.rewardState.changeToError(error)
      })
    },
    changeRule () {
      this.getAllrules()
      this.getAppRules()
      this.activeSection = Step.ChangeRule
      WizardManager.createWizard(Step.ChangeRule, this.contest)
    },
    getAllrules () {
      Rule.getAllRules().then((resp) => {
        this.publicRules = resp
        this.statePublicRules.changeToLoaded()
      }).catch((error) => {
        this.statePublicRules.changeToError(error)
      })
    },
    goToFGContest (contest) {
      if (contest.key) {
        this.$router.push({ name: 'FGContest', params: { 'key': contest.key } })
      }
    },
    getAppRules () {
      Rule.getAppRules().then((resp) => {
        this.appRules = resp
        this.stateAppRules.changeToLoaded()
      }).catch((error) => {
        this.stateAppRules.changeToError(error)
      })
    },
    editReward () {
      this.getAllreward()
      this.getAppRewards()
      this.activeSection = Step.ChangeReward
      WizardManager.createWizard(Step.ChangeReward, this.contest)
    },
    getAllreward () {
      Reward.getAllRewards().then((resp) => {
        this.publicRewards = resp
        this.statePublicRewards.changeToLoaded()
      }).catch((error) => {
        this.statePublicRewards.changeToError(error)
      })
    },
    getAppRewards () {
      Reward.getAppRewards().then((resp) => {
        this.appRewards = resp
        this.stateAppRewards.changeToLoaded()
      }).catch((error) => {
        this.stateAppRewards.changeToError(error)
      })
    },
    rewardsaved () {
      this.editReward()
      WizardManager.flow.pop()
      WizardManager.stateData = this.contest
      localStorage.setItem('wizardManager', JSON.stringify(WizardManager))
    },
    rulesaved () {
      this.changeRule()
      WizardManager.flow.pop()
      WizardManager.stateData = this.contest
      localStorage.setItem('wizardManager', JSON.stringify(WizardManager))
    },
    updatedRuleInfo (ruleInfo, type) {
      if (type === 'app') {
        this.appRules = ruleInfo
      } else {
        this.publicRules = ruleInfo
      }
    },
    updatedRewardInfo (rewardInfo, type) {
      if (type === 'app') {
        this.appRewards = rewardInfo
      } else {
        this.publicRewards = rewardInfo
      }
    },
    editSettings () {
      this.activeSection = Step.ChangeSettings
      WizardManager.createWizard(Step.ChangeSettings, this.contest)
    },
    saveRule (e) {
      this.contest.rule = e
      this.$emit('saveContest', this.contest)
      this.activeSection = Step.ReviewContest
      WizardManager.flow.pop()
      WizardManager.stateData = this.contest
      localStorage.setItem('wizardManager', JSON.stringify(WizardManager))
    },
    saveReward (e) {
      this.contest.reward = e
      this.$emit('saveContest', this.contest)
      this.activeSection = Step.ReviewContest
      WizardManager.flow.pop()
      WizardManager.stateData = this.contest
      localStorage.setItem('wizardManager', JSON.stringify(WizardManager))
    },
    createRule () {
      this.ruleKey = null
      this.activeSection = Step.CreateRule
      WizardManager.createWizard(Step.CreateRule, this.contest)
    },
    createReward () {
      this.rewardKey = null
      this.activeSection = Step.CreateReward
      WizardManager.createWizard(Step.CreateReward, this.contest)
    },
    createGame () {
      this.activeSection = Step.CreateGame
      WizardManager.createWizard(Step.CreateGame, this.contest)
    },
    saveGame () {
      this.activeSection = Step.ReviewContest
      WizardManager.createWizard(Step.ReviewContest, this.contest)
      this.$emit('saveGame')
    },
    editRule (key) {
      this.ruleKey = key
      this.activeSection = Step.CreateRule
      WizardManager.createWizard(Step.CreateRule, this.contest)
    },
    editRewardInfo (key) {
      this.rewardKey = key
      this.activeSection = Step.CreateReward
      WizardManager.createWizard(Step.CreateReward, this.contest)
    }
  }
}
</script>
